module.exports = __webpack_public_path__ + "static/media/calm-serene.3d1abef2.png";